module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "add_order_watch main_container pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("售后信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.returnUpperLevel()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "watch_msg table_container"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("售后单号：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.AsOrderNo))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("订单号：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.OrderNo))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("售后类型：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.TypeName))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("状态：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.StatusName))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("商品名称：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.GoodsName))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("数量：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.Counts))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("申请原因：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.GetAfterSaleDeatil.Remark))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("申请图片：")]), _vm._v(" "), _vm._l((_vm.GetAfterSaleDeatil.afterSalesImgs), function(itemImgUrl) {
    return _c('p', {
      key: itemImgUrl.ImgUrl
    }, [_c('el-image', {
      staticClass: "imgUrl",
      attrs: {
        "src": itemImgUrl.ImgUrl,
        "preview-src-list": [itemImgUrl.ImgUrl]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "afterSales"
  }, [_c('div', {
    staticClass: "afterSalesTitle"
  }, [_vm._v("售后进度：")]), _vm._v(" "), _c('el-steps', {
    attrs: {
      "space": 130,
      "active": _vm.active,
      "align-center": "",
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "提交审核"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "商家审核"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [(_vm.GetAfterSaleDeatil.StatusId == 16) ? _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.downToExamine()
      }
    }
  }, [_vm._v("审核")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.GetAfterSaleDeatil.StatusId == 18) ? [_c('el-step', {
    attrs: {
      "title": "商家驳回"
    }
  })] : [_c('el-step', {
    attrs: {
      "title": "审核通过"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "维修中"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "完成"
    }
  })]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "tableDiv"
  }, [_c('el-table', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "data": _vm.GetAfterSaleDeatil.afterSalesFlows
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "StatusName",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.Remark))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "WorkTime",
      "label": "时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.WorkTime))])]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "width": "40%",
      "title": "商家审核",
      "center": true,
      "visible": _vm.isToExamine
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入审核备注",
      "maxlength": "200",
      "rows": 3
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.rejectToExamine()
      }
    }
  }, [_vm._v("驳 回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.adoptToExamine()
      }
    }
  }, [_vm._v("通 过")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f4cb52aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/serviceRepair.vue
// module id = 1758
// module chunks = 3